import { render, staticRenderFns } from "./ViewScopingIntroduction.vue?vue&type=template&id=37a647de"
import script from "./ViewScopingIntroduction.vue?vue&type=script&lang=js"
export * from "./ViewScopingIntroduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports